module.exports = __webpack_public_path__ + "bb0e3c8fd65dc9087a36745827c24689.pdf";